/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_ThursdayInputs */

const fr_week_session_day_names_thursday = /** @type {(inputs: Week_Session_Day_Names_ThursdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu`)
};

/**

* @param {Week_Session_Day_Names_ThursdayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_thursday = /** @type {((inputs?: Week_Session_Day_Names_ThursdayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_ThursdayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_thursday(inputs)
});